module.exports = __webpack_public_path__ + "media/images/admin2/Nav__handle-a24c5d2010340e7b135e4847046ac0be.svg";